import { useNavigate } from 'react-router-dom';
import { PAGE_TEMPLATES, TEMPLATE_GROUPS } from '../../config/templates';

export function TemplatesGrid() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      {TEMPLATE_GROUPS.map((group) => {
        const groupTemplates = PAGE_TEMPLATES.filter((t) => group.templateIds.includes(t.id));
        return (
          <div key={group.id}>
            <h3 className="text-lg font-bold text-gray-900 mb-1 flex items-center gap-2">
              <span>{group.icon}</span> {group.title}
            </h3>
            <p className="text-sm text-gray-500 mb-3">{group.description}</p>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
              {groupTemplates.map((tpl) => (
                <button
                  key={tpl.id}
                  onClick={() => navigate(`/editor?template=${tpl.id}`)}
                  className="bg-white border border-gray-200 rounded-xl p-4 text-left hover:border-indigo-300 hover:shadow-md transition-all group"
                >
                  <div className="text-2xl mb-2">{tpl.icon}</div>
                  <h4 className="font-semibold text-gray-900 text-sm group-hover:text-indigo-600 transition-colors">{tpl.title}</h4>
                  <p className="text-xs text-gray-500 mt-1 line-clamp-2">{tpl.description}</p>
                  <p className="text-xs text-gray-400 mt-2">{tpl.slotCount} Felder</p>
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
